const WalletLoadedEvent = "hederaWalletLoaded";
const WalletUpdatedEvent = "hederaWalletUpdated";
const WalletLockedEvent = "hederaWalletLocked";
var HederaNetwork;
(function (HederaNetwork) {
  HederaNetwork["Mainnet"] = "mainnet";
  HederaNetwork["Testnet"] = "testnet";
})(HederaNetwork || (HederaNetwork = {}));

module.exports = {
  WalletLoadedEvent,
  WalletUpdatedEvent,
  WalletLockedEvent,
  HederaNetwork,
};
